import React from 'react';
import { ResponsiveContainer } from 'recharts';
import { useIsMobile } from '../../hooks/use-mobile';

// Единственное место, где живёт правило высоты графиков на мобильных.
// Десктопные высоты (300-500px) на телефоне занимают почти весь экран,
// поэтому сжимаем их, но не ниже читаемого минимума.
const MOBILE_SCALE = 0.65;
const MOBILE_MIN_HEIGHT = 220;
const MOBILE_MAX_HEIGHT = 300;

export function resolveChartHeight(desktopHeight, isMobile) {
  if (!isMobile || typeof desktopHeight !== 'number') return desktopHeight;

  return Math.max(
    MOBILE_MIN_HEIGHT,
    Math.min(MOBILE_MAX_HEIGHT, Math.round(desktopHeight * MOBILE_SCALE))
  );
}

/**
 * Drop-in замена recharts ResponsiveContainer: принимает десктопную высоту
 * и сама пересчитывает её для узких экранов.
 */
export function ResponsiveChart({ height, children, ...props }) {
  const isMobile = useIsMobile();

  return (
    <ResponsiveContainer width="100%" height={resolveChartHeight(height, isMobile)} {...props}>
      {children}
    </ResponsiveContainer>
  );
}

export default ResponsiveChart;
